import { useEffect, useState } from 'react';
import { getDatabase, ref, onValue} from "firebase/database";

/**
 * useAppState - create custom hooks for manage all firebase data,
 * 
 * @returns {appState} - apps state contains all firebase object.
 */

const useAppState = () => {
  const [appState, setAppState] = useState();
  const db = getDatabase();

  const initRealTimeDatabaseObservation = () => {
    const homePageSliderRef = ref(db, 'json_feeds/homepage');
    const homePageSliderLiveRef = ref(db, 'json_feeds/live');
    const homePageTeaserSliderRef = ref(db, 'leagues');
    const allEventsRef = ref(db, 'betonfire_bl_2/all_events');
    const allLeaguesRef = ref(db, 'betonfire_bl_2/all_leagues');
    const allMarketsRef = ref(db, 'betonfire_bl_2/all_markets');
    const popularRef = ref(db, 'betonfire_bl_2/popular/popular_sports');
    const teaserRef = ref(db, 'betonfire_bl_2/teaser');
    const featuredRef = ref(db, 'betonfire_bl_2/featured');

    onValue(homePageSliderRef, (snapshot) => {
      const data = snapshot.val();
      window.akilliBahisDatabase.homePageSlider = data;
      setAppStateData?.()
    });
    onValue(homePageSliderLiveRef, (snapshot) => {
      const data = snapshot.val();
      window.akilliBahisDatabase.homePageSliderLive = data;
      setAppStateData?.()
    });
    onValue(homePageTeaserSliderRef, (snapshot) => {
      const data = snapshot.val();
      window.akilliBahisDatabase.homePageTeaserSlide = data;
      setAppStateData?.()
    });
    onValue(allEventsRef, (snapshot) => {
      const data = snapshot.val();
      window.akilliBahisDatabase.allEventsData = data;

      // At this point, we need to flatten the data
      window.akilliBahisDatabase.allEventsData.forEach((element, index) => {
        const randomIndex = Math.floor(Math.random() * element?.suggestions?.length);
        const suggestion = element?.suggestions[randomIndex];
        Object.assign(window.akilliBahisDatabase.allEventsData[index], suggestion);
        delete window.akilliBahisDatabase.allEventsData[index].suggestions;
      });

      setAppStateData?.()
    });
    onValue(allLeaguesRef, (snapshot) => {
      const data = snapshot.val();
      window.akilliBahisDatabase.allLeaguesData = data;
      setAppStateData?.()
    });
    onValue(allMarketsRef, (snapshot) => {
      const data = snapshot.val();
      window.akilliBahisDatabase.allMarketsData = data;
      setAppStateData?.()
    });
    onValue(popularRef, (snapshot) => {
      const data = snapshot.val();
      window.akilliBahisDatabase.popularData = data;
      setAppStateData?.()
    });
    onValue(teaserRef, (snapshot) => {
      const data = snapshot.val();
      window.akilliBahisDatabase.teaserData = data;

      // At this point, we need to flatten the data
      window.akilliBahisDatabase.teaserData.forEach((element, index) => {
        const randomIndex = Math.floor(Math.random() * element?.suggestions?.length);
        const suggestion = element?.suggestions[randomIndex];
        Object.assign(window.akilliBahisDatabase.teaserData[index], suggestion);
        delete window.akilliBahisDatabase.teaserData[index].suggestions;
      });

      setAppStateData?.()
    });
    onValue(featuredRef, (snapshot) => {
      const data = snapshot.val();
      window.akilliBahisDatabase.featuredData = data;

      // At this point, we need to flatten the data
      window.akilliBahisDatabase.featuredData.forEach((element, index) => {
        const randomIndex = Math.floor(Math.random() * element?.suggestions?.length);
        const suggestion = element?.suggestions[randomIndex];
        Object.assign(window.akilliBahisDatabase.featuredData[index], suggestion);
        delete window.akilliBahisDatabase.featuredData[index].suggestions;
      });

      setAppStateData?.()
    });
  }
  const setAppStateData = () => {
    setAppState({
      fireBaseHomePageSliderDataBase: window.akilliBahisDatabase?.homePageSlider,
      fireBaseHomePageSliderLiveDataBase: window.akilliBahisDatabase?.homePageSliderLive,
      fireBaseHomePageTeaserSliderDataBase: window.akilliBahisDatabase?.homePageTeaserSlide,
      fireBaseAllEventsDataBase: window.akilliBahisDatabase?.allEventsData,
      fireBaseAllLeaguesDataBase: window.akilliBahisDatabase?.allLeaguesData,
      fireBaseAllMarketsDataBase: window.akilliBahisDatabase?.allMarketsData,
      fireBasePopularOddsDataBase: window.akilliBahisDatabase?.popularData,
      fireBaseTeaserDataBase: window.akilliBahisDatabase?.teaserData,
      fireBaseFeaturedDataBase: window.akilliBahisDatabase?.featuredData
    })
  }
  useEffect(() => {
    initRealTimeDatabaseObservation()
    // eslint-disable-next-line
  }, [])
  
  
    return {
        appState
    }
}

export default useAppState;